//import { isFakeTouchstartFromScreenReader } from '@angular/cdk/a11y';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PrismService } from '../../Prism.service';
import { RequestsService } from '../../Services/requests.service';
import Swal from 'sweetalert2';
import { UserService } from '../../Services/userservice.service';
import * as moment from 'moment';

import { options } from '../../forms/builder/options';
import { AppConfig } from '../../config';

//import 'animate.css'
import { FacephiService } from '../../Services/facephi.service';

import { MetaDataService } from '../../Services/metadata.service';


@Component({
    selector: 'app-formrenderer',
    templateUrl: './formrenderer.component.html',
    styleUrls: ['./formrenderer.component.scss']
})
export class FormrendererComponent implements AfterViewInit, OnInit {


    nombre_form = ""
    portalid = 0
    guid = "";
    hsform: any = {}
    form: any = {}
    url = AppConfig.url_backend;
    formaux: any = {}
    genero: string;
    departamento: string;
    estadoCivil: string;
    urlThanks: string;
    utmContent: string;
    utmMedium: string;
    utmSource: string;
    utmCampaign: string;


    //Manejo de las funcionalidades de IA
    tokenFacePhi: any = '';
    mostrarDoc: boolean;

    //Variables para validar si el formulario trae la funcionalidad
    ocr: boolean = false;
    lifeValidation: boolean = false;
    documentValidation: boolean = false;
    onboarding: boolean = false;
    countryCod: string = '';
    numberIdentify: string = '';
    token: string | any
    dataOnboarding: any = {}
    flag = false;

    //Metadata credolab
    analizarCredolab:boolean = false;
    formDom:any;
    stopCredolab:boolean = false;

    //Variables para el control de los widgets
    showBiometric: boolean = false;
    showDocument: boolean = false;

    imgFace: any = '';
    responseOCR: any = {}

    isLoading: boolean = false;


    public options: any = options;
    public Utm: any;
    public infografia: boolean;
    public infografiaMobil: boolean;

    constructor(
        public prism: PrismService,
        public requests: RequestsService,
        private rutaActiva: ActivatedRoute,
        private router: Router,
        private userService: UserService,
        private facephiService: FacephiService,
        private metadataS: MetaDataService,
        private elRef: ElementRef
    ) {
        this.infografia = true;
        this.infografiaMobil = true;
        this.mostrarDoc = false;
    }

    ngOnInit(): void {
        //obtener el valor de los utm
        this.getUtm();

        //============= CREDOLAB =====================
        this.metadataS.dataForm.subscribe((e:any) =>{
            if(e == '') return;
            this.getInputsForm();
            console.log("Form ", e);
        })

        //=============  ONBOARDING ==========================
        this.facephiService.imgFace.subscribe(async (e: any) => {
            if (e == '') return;

            this.showBiometric = false;
            //this.showDocument = true;
            this.showDocument = false;
            this.dataOnboarding = e;

            //VALIDACION CONTRA EL BACKEND FACEPHI
            const identify = await Swal.fire({
                title: 'Por favor ingrese su número de identificación',
                input: 'number',
                icon: 'question',
                confirmButtonText: 'Ingresar',
                showConfirmButton: true,
                confirmButtonColor: '#001b71',
                iconColor: '#001b71'
            })

            if( identify.value ){
                this.numberIdentify = identify.value;
                const data = {
                    identify: this.numberIdentify,
                    cod: this.countryCod,
                    tokenImage: e.tokenImage,
                    SelphiTemplateRaw: e.templateRaw,
                    FaceBase64: e.imgFace
                }
    
                console.log("data ", data);    
                this.isLoading = true;
                this.facephiService.setExistCustomer(data);
    
                return
            }else {
               this.showBiometric = true;
            }
           
        });


        //VALIDACION CONTRA EL BACKEND FACEPHI
        this.facephiService.existCustomer.subscribe((e: any) => {
            if (e == "") return;

            e.token = this.dataOnboarding.token;
            this.facephiService.getCustomer(e).subscribe((response: any) => {
                this.isLoading = false;
                console.log(response);
                this.responseOCR = response['OCR'];
                this.mapFields();

                this.isLoading = false;
                this.showBiometric = false;
                this.showDocument = false;
            }, error => {
                console.log("error del customer ",error);
                if( error.status == 429 ){
                    Swal.fire({
                        icon: 'error',
                        title: 'Resultado',
                        text: `No se pudo validar que la información enviada sea correcta, intentelo de nuevo en 24 horas.`,
                        confirmButtonColor: '#001b71'
                    });
    
                    this.isLoading = false;
                    this.showBiometric = false;
                    this.showDocument = false;
                }else {
                    Swal.fire({
                        icon: 'success',
                        title: 'Resultado',
                        text: `Selfie Tomada con exito, por favor suba su documento`,
                        confirmButtonColor: '#001b71'
                    });
    
                    this.isLoading = false;
                    this.showBiometric = false;
                    this.showDocument = true;
                }
              
            });
        });


        this.facephiService.imagesDoc.subscribe((f: any) => {
            if (f == "") return;

            const data = {
                FrontBase64: f[0].imagen,
                BackBase64: f[1].imagen,
                FaceBase64: this.dataOnboarding.imgFace,
                ImageToken: this.dataOnboarding.tokenImage,
                SelphiTemplateRaw: this.dataOnboarding.templateRaw,
                CountryCode: this.countryCod,
                token: this.dataOnboarding.token
            }
            //console.log("Data almacenada ", this.dataOnboarding);
            console.log("DATA OBOARDIGN ", data );

            this.isLoading = true;
            this.facephiService.postOnboarding(data).subscribe(response => {

                this.responseOCR = response['OCR'];
                this.mapFields();

                Swal.fire({
                    icon: 'success',
                    title: 'Resultado',
                    text: `Información guardada correctamente`,
                    confirmButtonColor: '#001b71'
                });

                this.isLoading = false;
                this.showBiometric = false;
                this.showDocument = false;

            }, error => {
                if( error.status != 429 ){
                    const msjResponse = this.facephiService.messgeDiagnostic();
                    const diagnostic = error.error.Diagnostic;
                    let mensaje = ( msjResponse[diagnostic] ) ? msjResponse[diagnostic] : 'Ocurrió un error, por favor intentelo de nuevo';
                    mensaje = ( error.error.Message == 'No se pudo validar que el documento le pertenesca.')? 'El documento no le pertenece, inténtelo de nuevo.' : mensaje;
                    mensaje = ( error.error.Message && error.error.Message.includes('número de serie del documento') )? 'No se pudo obtener el número de serie del documento, La segunda captura que se le solicita, tiene que ser la parte trasera de su documento de identificación' : mensaje;

                    console.log("MJS ONBORDING", mensaje);

                    this.isLoading = false;
                    this.showBiometric = true;
                    this.showDocument = false;
                    this.isLoading = false;
                    Swal.fire({
                        icon: 'error',
                        title: 'Resultado',
                        text: mensaje,
                        confirmButtonColor: '#001b71'
                    })
                    return
                }else{
                    Swal.fire({
                        icon: 'error',
                        title: 'Resultado',
                        text: `No se pudo validar que la información enviada sea correcta, intentelo de nuevo en 24 horas.`,
                        confirmButtonColor: '#001b71'
                    });
    
                    this.isLoading = false;
                    this.showBiometric = false;
                    this.showDocument = false;
                }
            });
            return
        });


        //============== PRUEBA DE VIDA ====================
        this.facephiService.responseLifeLP.subscribe((e:any) => {
            this.showBiometric = false;
            if(e=="") return 
            this.facephiService.postLifeValidation(e).subscribe(
                (res:any)=>{
                    console.log("PRUEBA DE VIDA ",res);
                    if (this.lifeValidation) {
                        Swal.fire({
                            icon: 'success',
                            title: 'Resultado',
                            text: `Prueba de vida exitosa`,
                            confirmButtonColor: '#001b71'
                        })
                    }
    
                    if( this.ocr ){
                        this.imgFace = e.templateRaw;
                        this.showBiometric = false;
                        this.showDocument = true;
                        this.mostrarDoc = true;
                    }else {
                        this.lifeValidation = false;
                        this.enabledFormioForm();
                    }
                },
                (error:any)=>{
                    if( error.status != 429 ){
                        const msjResponse = this.facephiService.messgeDiagnostic();
                        const diagnostic = error.error.Diagnostic;
                        const mensaje = ( msjResponse[diagnostic] ) ? msjResponse[diagnostic] : 'No paso la prueba de vida, inténtelo de nuevo';
                        Swal.fire({
                            icon: 'error',
                            title: 'Resultado',
                            text: mensaje,
                            confirmButtonColor: '#001b71'
                        });
                        this.showBiometric = true;
                        return true;
                    }else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Resultado',
                            text: `No se pudo validar que la información enviada sea correcta, intentelo de nuevo en 24 horas.`,
                            confirmButtonColor: '#001b71'
                        });
                        this.lifeValidation = false;
                        this.isLoading = false;
                        this.showBiometric = false;
                        this.showDocument = false;
                        return false;
                    }
                });
        }); 


         //============= OCR ==========================
        this.facephiService.responseDocument.subscribe((e: any) => {
            if (e == '') return
            //console.log('Cambio en los valores');
            this.showDocument = false;


            const imagenFrontal = e?.[0]?.imagen?.split(',');
            const imagenBack = e?.[1]?.imagen?.split(',');

            this.isLoading = true;
            this.userService.getTokenFacephi().subscribe(
                (res: any) => {
                    console.log(res);
                    const token = res.token;

                    const data = {
                        image1: e[0].imagen,
                        faceTemplate: this.imgFace,
                        token: token,
                    }

                    this.facephiService.postVerifyDocument(data).subscribe(
                        (resp: any) => {
                            console.log( "Respuesta ", resp );
                            if (!resp.VerifiationStatus) {
                                this.showBiometric = true;
                                this.showDocument = false;
                                this.isLoading = false;
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Oops...',
                                    text: `El documento no le pertenece, inténtelo de nuevo`,
                                    confirmButtonColor: '#001b71'
                                })
                                this.showBiometric = true;
                                return
                            }

                            Swal.fire({
                                icon: 'success',
                                title: 'Resultado',
                                text: `El documento es válido, extrayendo la información del documento`,
                                confirmButtonColor: '#001b71'
                            })

                            console.log(imagenFrontal)
                            const dataOcr = {
                                form: this.nombre_form,
                                image1: imagenFrontal[1],
                                image2: imagenBack[1],
                                token: token
                            }

                            this.facephiService.postOCR(dataOcr).subscribe(
                                (res: any) => {
                                    this.responseOCR = res;

                                    if (typeof res !== "object") {
                                        Swal.fire({
                                            icon: 'error',
                                            title: 'Resultado',
                                            text: "Ocurrió un error al validar el tipo de documento, por favor de verificar que la primera imagen sea la parte delantera del documento y la segunda la parte tracera.",
                                            confirmButtonColor: '#001b71'
                                        });
                                        this.isLoading = false;
                                        this.showBiometric = true;
                                        return;
                                    }

                                    console.log(this.responseOCR);
                                    this.mapFields();
                                    this.isLoading = false;
                                },
                                (error: any) => {

                                    if( error.status == 429 ){
                                        Swal.fire({
                                            icon: 'error',
                                            title: 'Resultado',
                                            text: `No se pudo validar que la información enviada sea correcta, intentelo de nuevo en 24 horas.`,
                                            confirmButtonColor: '#001b71'
                                        });
                                        this.lifeValidation = false;
                                        this.isLoading = false;
                                        this.showBiometric = false;
                                        this.showDocument = false;
                                        return false;
                                    }else {
                                        if ((error.status === 400) || (typeof error !== "object")) {
                                            Swal.fire({
                                                icon: 'error',
                                                title: 'Resultado',
                                                text: "No se pudo obtener el numero de serie del documento, Por favor validar que el parametro Image2 sea de la parte trasera del documento",
                                                confirmButtonColor: '#001b71'
                                            });
                                            this.isLoading = false;
                                            this.showBiometric = true;
                                            return;
                                        }
    
                                        Swal.fire({
                                            icon: 'error',
                                            title: 'Resultado',
                                            text: `Ocurrió un error al obtener la información, intentálo más tarde.`,
                                            confirmButtonColor: '#001b71'
                                        });
                                        this.showBiometric = true;
                                        this.isLoading = false;
                                    }
                                }
                            )

                        },
                        (err: any) => {
                            console.log(err);
                            if( err.status != 429 ){
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Resultado',
                                    text: `Ocurrió un error al obtener la información, intentálo más tarde.`,
                                    confirmButtonColor: '#001b71'
                                })
                            }else {
                                Swal.fire({
                                    icon: 'error',
                                    title: 'Resultado',
                                    text: `No se pudo validar que la información enviada sea correcta, intentelo de nuevo en 24 horas.`,
                                    confirmButtonColor: '#001b71'
                                });
                                this.lifeValidation = false;
                                this.isLoading = false;
                                this.showBiometric = false;
                                this.showDocument = false;
                                return false;
                            }
                        }
                    )
                },
                (error: any) => {
                    console.log(error);
                }
            )
        })


        this.rutaActiva.params.subscribe(params => {
            
            this.nombre_form = params['nombre'];
            
        });

        this.requests.getFormbyId(this.nombre_form).subscribe(
            (res: any) => {
                if (res) {
                    this.form = JSON.parse(res[0].estructura_angular)
                    this.hsform = JSON.parse(res[0].estructura_hs_resp)
                    this.portalid = this.hsform.portalId
                    this.guid = this.hsform.guid;
                    this.formaux = JSON.parse(res[0].estructura_hs_crear)
                    this.urlThanks = res[0].url_thanks
                    

                    console.log("DATA FORM", this.formaux);

                    this.ocr = this.formaux.ocr || false;
                    this.lifeValidation = this.formaux.lifeValidation || false;

                    //============= Onboarding =======================
                    this.countryCod = this.formaux.CountryOnboarding || 'GTM';
                    // console.log("Country code ", this.formaux );
                    this.onboarding = this.formaux.onboarding || false;
                    this.facephiService.setIsOnboarding(this.onboarding);
                    //=============FIN Onboarding =======================


                    //============= CredoLab ====================
                    this.analizarCredolab = this.formaux.analizarCredolab || false;
                    this.metadataS.setDataForm(this.formaux);
                    //============ Fin CredoLab =================



                    //Si tiene alguna de las funcionalidades de inteligencia artificial obtiene el token para consumir los servicios de facephi
                    if (this.ocr || this.lifeValidation || this.onboarding) {
                        console.log("dataForm ", this.formaux);
                        this.userService.getTokenFacephi().subscribe(
                            (res: any) => {
                                this.showBiometric = true;
                                this.tokenFacePhi = res.token;
                                this.disabledFormioForm();
                            },
                            err => {
                                console.log(err);
                            }
                        )
                    }
                }
            },
            (err: any) => {
                console.log(err);
                return err;
            }
        );

        this.onPropagar();
    }



    cerrarInfografia(){
        this.infografia = false;
        this.showBiometric = true;
        console.log(this.showBiometric);
    }

    cerrarInfografiaMobil(){
        this.infografiaMobil = false;
        console.log("touch");
    }

    ngOnDestroy() {
        this.facephiService.responseLife.unsubscribe();
        this.facephiService.responseDocument.unsubscribe();
    }


    mapFields() {
        this.enabledFormioForm();
        const inputs = document.querySelectorAll('formio div div div div div input');
        const selects = document.querySelectorAll('formio select');
        const form = this.form;
        if (this.flag) {
            return
        }

        console.log("RSP OCR ", this.responseOCR)
        inputs.forEach((userItem: any) => {

            if (userItem.name == "data[firstname]") {
                if (this.responseOCR.Nombre == "<nil>") return
                userItem.value = this.responseOCR.Nombre;
                let event = new Event('input', { bubbles: true, cancelable: true })
                userItem.dispatchEvent(event);
            }
            if (userItem.name == "data[lastname]") {
                if (this.responseOCR.Apellidos == "<nil>") return
                userItem.value = this.responseOCR.Apellidos;
                let event = new Event('input', { bubbles: true, cancelable: true })
                userItem.dispatchEvent(event);
            }
            if (userItem.name == "data[primer_nombre]") {
                if (this.responseOCR.Nombre == "<nil>") return
                userItem.value = this.responseOCR.Nombre;
                let event = new Event('input', { bubbles: true, cancelable: true })
                userItem.dispatchEvent(event);
            }
            if (userItem.name == "data[segundo_nombre]") {
                if (this.responseOCR.Nombre == "<nil>") return
                userItem.value = this.responseOCR.Nombre;
                let event = new Event('input', { bubbles: true, cancelable: true })
                userItem.dispatchEvent(event);
            }
            if (userItem.name == "data[dpi]" || userItem.name == "data[Identify]") {
                if (this.responseOCR.Dpi == "<nil>") return
                userItem.value = (this.responseOCR.Dpi) ? this.responseOCR.Dpi : this.responseOCR.Identify;
                let event = new Event('input', { bubbles: true, cancelable: true })
                userItem.dispatchEvent(event);
            }

            if (userItem.name == "data[fecha_de_nacimiento]") {
                if (this.responseOCR["Fecha"] == "<nil>") return
                const fecha = this.responseOCR.Fecha.split('/');
                let event = new Event('change', { bubbles: true, cancelable: true })
                let eventInput = new Event('input', { bubbles: true, cancelable: true })
                //let eventClick = new Event('click', {bubbles: true, cancelable:true})

                //const flatpicker = document.getElementsByClassName('flatpickr-calendar')[0];
                // userItem.nextElementSibling.dispatchEvent(focus);
                //userItem.nextElementSibling.dispatchEvent(eventClick);
                //userItem.nextElementSibling.value = "1998-10-09";
                //userItem.value = "1998-10-09";
                userItem.nextElementSibling.value = `${fecha[2]}-${fecha[1]}-${fecha[0]}`;
                userItem.value = `${fecha[2]}-${fecha[1]}-${fecha[0]}`;
                //userItem.value = "1998-10-09";
                userItem.nextElementSibling.dispatchEvent(eventInput);
                userItem.nextElementSibling.dispatchEvent(event);
                userItem.dispatchEvent(event);
                userItem.dispatchEvent(eventInput);
                userItem.parentElement.parentElement.parentElement.dispatchEvent(event);

                //flatpicker.dispatchEvent(eventInput)
                //flatpicker.dispatchEvent(event)
            }

            if( userItem.name == "data[edad]"){
                userItem.value = (this.responseOCR.Edad) ? this.responseOCR.Edad : this.responseOCR.Edad;
                let event = new Event('input', { bubbles: true, cancelable: true })
                userItem.dispatchEvent(event);
            }

            if( userItem.name == "data[municipio_de_residecia]"){
                userItem.value = (this.responseOCR.Municipio) ? this.responseOCR.Municipio : this.responseOCR.Municipio;
                let event = new Event('input', { bubbles: true, cancelable: true })
                userItem.dispatchEvent(event);
            }

 
            if( userItem.name == "data[direccion]"){
                userItem.value = (this.responseOCR.Vecindad) ? this.responseOCR.Vecindad : this.responseOCR.Vecindad;
                let event = new Event('input', { bubbles: true, cancelable: true })
                userItem.dispatchEvent(event);
            }


        });


        if (!selects) return;

        selects.forEach((element: any) => {
            element.value = this.primeraMayuscula(element.value);
            const padre = element.parentElement;
            const agregar:any = element.nextElementSibling;
            const hermano = padre.nextElementSibling;
            const opciones = hermano.querySelector(".choices__list");
            const opcionSelect = document.createElement('option');

            let opcion = '';
            if( element.name == "data[departamento]"){
                opcion = this.primeraMayuscula(this.responseOCR.Departamento);
                this.departamento = this.primeraMayuscula(this.responseOCR.Departamento);

            }

            if( element.name == "data[bm_estado_civil]"){
                opcion = this.primeraMayuscula(this.responseOCR.EstadoCivil);
                this.estadoCivil = this.primeraMayuscula(this.responseOCR.EstadoCivil);
            }

            if( element.name == "data[genero]"){
                opcion = this.primeraMayuscula(this.responseOCR.Genero);
                this.genero = this.primeraMayuscula(this.responseOCR.Genero);
            }

            console.log("opcion ", opcion);

            if( !opcion ) return;
            try {
                const opcionElegir = opciones.querySelector(`div[data-value=${opcion}]`);
                if (opcionElegir) {
                    opcionSelect.value = opcion;
                    opcionSelect.innerHTML = `&lt;span&gt;${opcion}&lt;/span&gt;`;
                    element.append(opcionSelect);
                    opcionElegir.setAttribute("aria-selected", "true");
                    agregar.append(opcionElegir);
    
                    element.value = opcion;
                    element.dispatchEvent(new Event('change'));
                    element.dispatchEvent(new Event('change'));
                    return
                }
            } catch (error) {
                return true;
            }
        });
    }

    primeraMayuscula(name:string):string {
        if( !name ) return '';
        if( name.split(" ").length > 1 ){
            let result = '';
            name.split(" ").forEach( e => {
                e = e.toLowerCase();
                let prmLetra = e.substring(0,1);
                e = e.substring(1, e.length);
                prmLetra = prmLetra.toUpperCase();
                result = `${result} ${prmLetra + e}` ;
            });
            return result;
        }else {
            let opcion = name;
            opcion = opcion.toLowerCase();
            let prmLetra = opcion.substring(0,1);
            opcion = opcion.substring(1, opcion.length);
            prmLetra = prmLetra.toUpperCase();
            return prmLetra + opcion;
        }
    }

    capitalize(sentence) {
        return sentence && sentence[0].toUpperCase() + sentence.slice(1);
    }

    enabledFormioForm() {
        const inputs = document.querySelectorAll('formio div div div div div input');
        const select = document.querySelectorAll('formio div div div div div select');

        //Para habilitar los inputs del formulario
        inputs.forEach(function (userItem) {
            userItem.removeAttribute('disabled');
        });

        select.forEach(function (element:any) {
            element.parentElement.style.border = '1px solid #e2e8f0';
            element.parentElement.parentElement.style.pointerEvents = 'auto';
        });
    }


    disabledFormioForm() {
        const inputs = document.querySelectorAll('formio div div div div div input');
        const select = document.querySelectorAll('formio div div div div div select');
        //Para deshabilitar los inputs del formulario
        inputs.forEach(function (userItem) {
            userItem.setAttribute('disabled', '');
        });

        select.forEach(function (element:any) {
            element.parentElement.style.background = 'rgb(234 235 236)';
            element.parentElement.style.border = 'none';
            element.parentElement.parentElement.style.pointerEvents = 'none';
        });
    }

    onPropagar() {
        this.userService.emitChange("Diseño del Formulario")
    }

    ngAfterViewInit() {
        this.prism.init();
    }

    //Cambiar los id de los campos del formulario 
    getInputsForm(){
        const inputs = this.elRef.nativeElement.querySelectorAll('input,select,textarea');
        const button = this.elRef.nativeElement.querySelector('button[type=submit]');
        console.log("boton ", button);
        if(inputs.length > 0 ){
            button.setAttribute('id','submit_button');
            inputs.forEach((e:any)=> {
                const elementName = e.name.replace(/^data\[(.*)\]$/, '$1');
                //e.setAttribute('id', `${elementName}-${this.guid}`);
               // e.setAttribute('id', `${elementName}-16a54991-6f13-47c5-91ea-ed939797f216_3335`);
            })
            return
        }

        setTimeout(()=>{
            this.getInputsForm();
        },400)
    }


    //Iniciar Credolab
    ChangeForm(e:any){
       // this.metadataS.CreateReferencesNumber();
        let element:any = e.target;
        const startCreolab = this.formaux.startCredolab;
       // const elementName = element.name.replace(/^data\[(.*)\]$/, '$1');
        const elementName = element.name.toUpperCase();

        //Iniciar credolab
        if( this.analizarCredolab && elementName.includes(`[${startCreolab.toUpperCase()}]`) &&  !this.metadataS.referencesNumber  ){
            this.metadataS.InitCredoLabService();
            this.metadataS.StartCredoLabService();
            //console.log("Number References ", this.metadataS.referencesNumber);
        }

    }



       

    //llenar los utm con los valores que vienen desde la url
    getUtm() {
        this.rutaActiva.queryParams.subscribe(params => {
            this.Utm = [
                { "name": "utm_campaign", "value": (params.utm_campaign) ? params.utm_campaign : "" },
                { "name": "utm_source", "value": (params.utm_source) ? params.utm_source : "" },
                { "name": "utm_content", "value": (params.utm_content) ? params.utm_content : "" },
                { "name": "utm_medium", "value": (params.utm_medium) ? params.utm_medium : "" }
            ];
        });
    }

    

    //Metodo de envio mejorado
    async onSubmitv2(event) {
        console.log("Event ", event);
       /* if(event.data.departamento == '') event.data.departamento = ( event.data.departamento ) ? event.data.departamento: this.departamento;
        if(event.data.bm_estado_civil == '') event.data.bm_estado_civil = ( event.data.bm_estado_civil ) ? event.data.bm_estado_civil: this.estadoCivil;
        if( event.data.genero == '') event.data.genero = ( event.data.genero ) ? event.data.genero: this.genero;*/

        this.rutaActiva.queryParams.subscribe(params => {
                 this.utmCampaign = (params.utm_campaign) ? params.utm_campaign : "";
                 this.utmSource = (params.utm_source) ? params.utm_source : "";
                 this.utmContent = (params.utm_content) ? params.utm_content : "";
                 this.utmMedium = (params.utm_medium) ? params.utm_medium : "";
        });
        

        setTimeout(() => {
            let msgalert = document.getElementsByClassName("alert alert-success");
            if (msgalert != undefined && msgalert.length > 0) {
                msgalert[0].setAttribute("style", "display:none;");
            }
        }, 20);

        const urlForm = this.router.parseUrl(this.router.url);
        let site = urlForm.queryParams['site'] || null;


        let data = {
            fields: [],
            "context": {
                "hutk": this.requests.getCookie('hubspotutk'),
                //"pageUri": "https://apiformulariosdigitales.bi.com.gt/",
                //"pageName": "Administrador de Formularios",
                "pageUri": site || window.location.href,
                "pageName": window.document.title
            },
            isOnboarding: false,
            isCredolab: false
        }


        /*console.log("componentes ", this.form.components);
        console.log("event", event.data );
        return */


        for (const component of this.form.components) {
            //console.log(component);
            for (const prop in event.data) {
               // console.log("prop: ", prop);
                if (prop != "submit") {
                 //   console.log("3**********SUBMIT******************: ", component);
                    if (component.type == "file") {
                        if (component.key == prop) {
                            if (event.data[prop][0] == undefined) break;
                            const response = await fetch(`${this.url}/upload`, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/json'
                                },
                                body: JSON.stringify({ url: event.data[prop][0].url, name: event.data[prop][0].name, ext: event.data[prop][0].name.split('.').pop(), size: event.data[prop][0].size })
                            })
                            let body = await response.json();
                            data.fields.push({ name: component.key, value: body['data']['url'], tipo: 'url' })
                            break;
                        }
                    } else if (component.type === "selectboxes") {
                        if (component.key == prop) {
                            let selectedOptions = []
                            for (const e in event.data[prop]) {
                                if (event.data[prop][e]) {
                                    selectedOptions.push(e);
                                }
                            }
                            data.fields.push({ name: component.key, value: selectedOptions.join(';'), tipo: component.tipodato })
                            break;
                        }

                    } else if (component.type === "checkbox") {
                        if (component.key == prop) {
                            let val = '';
                            if (event.data[prop]) val = "true"
                            else val = "false"

                            data.fields.push({ name: component.key, value: val, tipo: component.tipodato })
                            break;
                        }
                    } else if (component.type === "datetime") {
                        if (component.key == prop) {
                            moment.locale('es');
                            const fecha = moment(event.data[prop]).format('YYYY-MM-DD');
                            //console.log('Esto trae la fecha', event.data[prop]);
                            console.log('Esto trae la fecha', typeof (fecha));

                            if (fecha != 'Fecha inválida') {
                                console.log('Es fecha valida');

                                data.fields.push({ name: component.key, value: fecha, tipo: component.tipodato });
                                break;
                            }
                        }
                    } else if (component.type === "textfield" || component.type == "textarea" || component.type == "radio" || component.type == "select" || component.type == "currency" || component.type == "number" || component.type == "numberDUI" ) {
                         if (component.key == prop) {
                            data.fields.push({ name: component.key, value: event.data[prop], tipo: component.tipodato });
                            break;
                        } else {
                            const isUTM = this.Utm.filter(e => e.name == component.key);
                            if (isUTM.length > 0) {
                                if (data.fields.some(d => d.name == component.key)) break;
                                data.fields.push({ name: component.key, value: isUTM[0].value, tipo: component.tipodato })
                                break;
                            }
                        } 

                    }
                    // console.log("component: ", component)
                    if (component.type == "container") {

                        if (prop == "container") {
                            // console.log("event.data[prop]: ", event.data[prop])
                            for (const key in event.data[prop] ) {

                                for (const iterator of component.components) {
                                  
                                   // console.log("2**********CONTAINER******************: ", iterator);
                                    //  console.log('En container ', compa );
                                    if (iterator.type == "file") {
                                        if (iterator.key == key) {
                                            if (event.data[prop][key][0] == undefined) break;
                                            //console.log('Es un tipo archivo', event.data[prop][0]);
                                            const response = await fetch(`${this.url}/upload`, {
                                                method: 'POST',
                                                headers: {
                                                    'Content-Type': 'application/json'
                                                },
                                                body: JSON.stringify({ url: event.data[prop][key][0].url, name: event.data[prop][key][0].name, ext: event.data[prop][key][0].name.split('.').pop(), size: event.data[prop][key][0].size })
                                            })
                                            let body = await response.json();
                                            data.fields.push({ name: iterator.key, value: body['data']['url'], tipo: 'url' })
                                            break;
                                        }
                                    } else if (iterator.type == "selectboxes") {
                                        if (iterator.key == key) {
                                            let selectedOptions = []
                                            for (const e in event.data[prop][key]) {
                                                if (event.data[prop][key][e]) {
                                                    selectedOptions.push(e);
                                                }
                                            }
                                            data.fields.push({ name: iterator.key, value: selectedOptions.join(';'), tipo: iterator.tipodato })
                                            break;
                                        }
                                    } else if (iterator.type == "checkbox") {
                                        if (iterator.key == key) {
                                            let val = '';
                                            if (event.data[prop][key]) val = "true"
                                            else val = "false"
                                            data.fields.push({ name: iterator.key, value: val, tipo: iterator.tipodato })
                                            break;
                                        }
                                    } else if (iterator.type == "datetime") {
                                        if (iterator.key == key) {
                                            moment.locale('es');
                                            const fecha = moment(event.data[prop][key]).format('YYYY-MM-DD');
                                            //if(event.data[prop][key] == '') break;
                                            if (fecha != 'Fecha inválida') {
                                                data.fields.push({ name: iterator.key, value: fecha, tipo: iterator.tipodato });
                                                break;
                                            }
                                        }
                                    } else if (iterator.type == "textfield" || iterator.type == "textarea" || iterator.type == "select" || iterator.type == "radio" || iterator.type == "currency" || iterator.type == "number" || component.type == "numberDUI")  {

                                         if (iterator.key == key) {
                                            data.fields.push({ name: key, value: event.data[prop][key], tipo: iterator.tipodato });
                                            break;
                                        } else {
                                            const isUTM = this.Utm.filter(e => e.name == key);
                                            if (isUTM.length > 0) {
                                                if (data.fields.some(d => d.name == key)) break;
                                                data.fields.push({ name: key, value: isUTM[0].value, tipo: iterator.tipodato })
                                                break;
                                            }
                                        } 

                                    } else if (iterator.type == "columns") {
                                        for (const compon of iterator.columns) {
                                            for (const comp of compon.components) {
                                                // console.log('Componentes en columna', comp);
                                                if (comp.type == "file") {
                                                    if (comp.key == key) {
                                                        if (event.data[prop][key][0] == undefined) break;
                                                        const response = await fetch(`${this.url}/upload`, {
                                                            method: 'POST',
                                                            headers: {
                                                                'Content-Type': 'application/json'
                                                            },
                                                            body: JSON.stringify({ url: event.data[prop][key][0].url, name: event.data[prop][key][0].name, ext: event.data[prop][key][0].name.split('.').pop(), size: event.data[prop][key][0].size })
                                                        })
                                                        let body = await response.json();
                                                        data.fields.push({ name: comp.key, value: body['data']['url'], tipo: 'url' })
                                                        break;
                                                    }
                                                } else if (comp.type == "selectboxes") {
                                                    if (comp.key == key) {
                                                        let selectedOptions = []
                                                        for (const e in event.data[prop][key]) {
                                                            if (event.data[prop][key][e]) {
                                                                selectedOptions.push(e);
                                                            }
                                                        }
                                                        data.fields.push({ name: comp.key, value: selectedOptions.join(';'), tipo: comp.tipodato })
                                                        break;
                                                    }
                                                } else if (comp.type == "checkbox") {
                                                    if (comp.key == key) {
                                                        let val = '';
                                                        if (event.data[prop][key]) val = "true"
                                                        else val = "false"
                                                        data.fields.push({ name: comp.key, value: val, tipo: comp.tipodato })
                                                        break;
                                                    }
                                                } else if (comp.type == "datetime") {
                                                    if (comp.key == key) {
                                                        moment.locale('es');
                                                        const fecha = moment(event.data[prop][key]).format('YYYY-MM-DD');
                                                        //if(event.data[prop][key] = '') break;
                                                        if (fecha != 'Fecha inválida') {
                                                            data.fields.push({ name: comp.key, value: fecha, tipo: comp.tipodato });
                                                            break;
                                                        }
                                                    }
                                                } else if (comp.type == "textfield" || comp.type == "textarea" || comp.type == "radio" || comp.type == "select" || comp.type == "currency" || comp.type == "number" || component.type == "numberDUI") {
                                                    //console.log("comp.key: ", comp.key);
                                               
                                                     if (comp.key == prop) {
                                                        data.fields.push({ name: comp.key, value: event.data[prop], tipo: comp.tipodato });
                                                        break;
                                                    } else {
                                                        const isUTM = this.Utm.filter(e => e.name == comp.key);
                                                        if (isUTM.length > 0) {
                                                            if (data.fields.some(d => d.name == comp.key)) break;
                                                            data.fields.push({ name: comp.key, value: isUTM[0].value, tipo: comp.tipodato })
                                                            break;
                                                        }
                                                    } 
                                                }
                                            }
                                        }
                                    }
                                }


                            }
                        }

                    }

                    if (component.type === "columns") {
                        for (const columns of component.columns) {
                            for (const comp of columns.components) {

                              //  console.log("1**********COLUMNS******************: ", comp);

                                if (comp.type == "file") {
                                    if (comp.key == prop) {
                                        if (event.data[prop][0] == undefined) break;
                                        const response = await fetch(`${this.url}/upload`, {
                                            method: 'POST',
                                            headers: {
                                                'Content-Type': 'application/json'
                                            },
                                            body: JSON.stringify({ url: event.data[prop][0].url, name: event.data[prop][0].name, ext: event.data[prop][0].name.split('.').pop(), size: event.data[prop][0].size })
                                        })
                                        let body = await response.json();
                                        data.fields.push({ name: comp.key, value: body['data']['url'], tipo: 'url' })
                                        break;
                                    }
                                } else if (comp.type == "selectboxes") {
                                    if (comp.key == prop) {
                                        let selectedOptions = []
                                        for (const e in event.data[prop]) {
                                            if (event.data[prop][e]) {
                                                selectedOptions.push(e);
                                            }
                                        }
                                        data.fields.push({ name: comp.key, value: selectedOptions.join(';'), tipo: comp.tipodato })
                                        break;
                                    }
                                } else if (comp.type == "checkbox") {
                                    if (comp.key == prop) {
                                        let val = '';
                                        if (event.data[prop]) val = "true"
                                        else val = "false"
                                        data.fields.push({ name: comp.key, value: val, tipo: comp.tipodato })
                                        break;
                                    }
                                } else if (comp.type == "datetime") {
                                    if (comp.key == prop) {
                                        moment.locale('es');
                                        const fecha = moment(event.data[prop]).format('YYYY-MM-DD');
                                        if (fecha != 'Fecha inválida') {
                                            data.fields.push({ name: comp.key, value: fecha, tipo: comp.tipodato });
                                            break;
                                        }
                                    }
                                } else if (comp.type == "textfield" || comp.type == "textarea" || comp.type == "radio" || comp.type == "select" || comp.type == "currency" || comp.type == "number" || component.type == "numberDUI") {

                                        //?utm_campaign=Hola&utm_content=Hola&utm_source=Hola&utm_medium=mkvmkxv
                                    if (comp.key == prop) {
                                        data.fields.push({ name: comp.key, value: event.data[prop], tipo: comp.tipodato });
                                        break;
                                    } else {
                                        const isUTM = this.Utm.filter(e => e.name == comp.key);
                                        if (isUTM.length > 0) {
                                            if (data.fields.some(d => d.name == comp.key)) break;
                                            data.fields.push({ name: comp.key, value: isUTM[0].value, tipo: comp.tipodato })
                                            break;
                                        }
                                    } 


                                }
                            }
                        }
                    }

                }
            }
        }

        //Detener credoLab
        if(this.analizarCredolab){
           this.metadataS.CollectionData();
           data.fields.push({ name: 'credolab_numero_de_referencia', value: this.metadataS.referencesNumber, tipo: 'alfanumerico' });
           data.isCredolab=true;
        }

        
        //Envio de la data a husbpot
        //console.log("Componentes del formulario ", this.form.components);
        //console.log("is onboarding ", this.facephiService.isOnbarding['_value'] );
        if(this.facephiService.isOnbarding['_value']) data.isOnboarding = true;
        console.log('Datos a enviar: ', data);
        
        //return true;
        setTimeout(() => {
            this.requests.submit_form(data, this.portalid, this.guid).subscribe(
                res => {
                    //     console.log(res);
                    let msg = 'Gracias por enviar el formulario.';
                    if (res.inlineMessage) {
                        msg = res.inlineMessage
                    }

                    let scrollToTop = window.setInterval(() => {
                        let pos = window.pageYOffset;
                        if (pos > 0) {
                            window.scrollTo(0, pos - 20); // how far to scroll on each step
                        } else {
                            window.clearInterval(scrollToTop);
                        }
                    }, 16);

                    setTimeout(() => {
                        let msgalert = document.getElementsByClassName("alert alert-success");

                        if (msgalert != undefined && msgalert.length > 0) {
                            msgalert[0].innerHTML = msg
                            msgalert[0].removeAttribute("style");
                        }

                        let alert = document.getElementsByClassName("alert");



                        msgalert[0].setAttribute("style", "bottom:50px; z-index:10; left:50%; transform:translate(-50%, -50%);")
                        console.log(alert[0]);

                        /*for(let i = 0; i< alert.length; i++){
                          alert[0] = ";"
                        }*/
                    }, 20);

                    //=============PostMessage===========================
                        var querystring = "";
                        if(this.utmContent != ""){
                            querystring = "?utm_content="+this.utmContent+"&utm_source="+this.utmSource+"&utm_medium="+this.utmMedium+"&utm_campaign="+this.utmCampaign;
                        }else{
                            querystring = "";
                        }
                        const redirectUrl = this.urlThanks+querystring;  
                        console.log(this.utmContent)  
                        console.log(redirectUrl)
                        if(redirectUrl!=null || redirectUrl!=undefined){
                            try{
                                window.parent.postMessage(
                                    { action: 'formSubmitted', redirectUrl: redirectUrl },
                                    'http://localhost/' // Especifica el origen permitido
                                );
                                console.log("Ejecutado2");
                            }
                            catch(error){
                                console.log("no ejecutado2");
                            }   
                        }else{
                            setTimeout(() => {
                                window.location.reload();
                            }, 2000)
                        }
                             
                        
                    //=============PostMessage===========================

                    

                },
                err => {

                    setTimeout(() => {
                        let msgalert = document.getElementsByClassName("alert alert-success");
                        if (msgalert != undefined && msgalert.length > 0) {
                            msgalert[0].setAttribute("style", "display:none;");
                        }
                    }, 20);

                    console.log(err);
                    if (err.status == 429) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: err.error,
                        })
                        return
                    }

                    if (err.status == 'error') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: err.errors[0].message,
                        })
                        return
                    }

                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: `Ocurrió un error al envíar los datos del formulario`,
                    })
                }

            );

        }, 3000);



    }


}
